import { SkeletonElement } from '../../../../common';
import { css, stack } from '@bts-web/utils-style-engine';

export const PortfolioSummarySkeleton = () => (
  <div
    className={stack({
      gap: {
        base: 'extra_small_2',
        lg: 'medium',
      },
      paddingX: 'medium',
      paddingY: 'small',
      width: '100%',
    })}
    data-testid="portfolio-header-skeleton-container"
  >
    <SkeletonElement
      width="62px"
      height="16px"
      testId="portfolio-header-skeleton-title"
    />

    <div
      className={css({
        display: 'flex',
        gap: 'extra_small_2',
        alignItems: 'center',
        justifyContent: 'space-between',
        lg: {
          justifyContent: 'start',
          gap: 'medium',
        },
      })}
    >
      <div className={css({ hideFrom: 'lg' })}>
        <SkeletonElement
          width="231px"
          height="32px"
          testId="portfolio-header-skeleton-left"
        />
      </div>

      <div className={css({ hideBelow: 'lg' })}>
        <SkeletonElement
          width="231px"
          height="46px"
          testId="portfolio-header-skeleton-left"
        />
      </div>

      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'extra_small_2',
          alignItems: 'end',
          hideFrom: 'lg',
        })}
        data-testid="portfolio-header-skeleton-right"
      >
        <SkeletonElement width="70px" height="16px" />

        <SkeletonElement width="52px" height="18px" borderRadius="30px" />
      </div>

      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'extra_small_2',
          alignItems: 'end',
          hideBelow: 'lg',
        })}
        data-testid="portfolio-header-skeleton-right"
      >
        <SkeletonElement width="70px" height="16px" borderRadius="30px" />

        <SkeletonElement width="68px" height="27px" borderRadius="32px" />
      </div>
    </div>
  </div>
);
